module.exports = __webpack_public_path__ + "static/media/circledCheckmark.8b50632d.svg";